import React from 'react';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  itemName?: string;
  isLoading?: boolean;
  turmasVinculadas?: string[];
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  isLoading = false,
  turmasVinculadas
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="d-flex align-items-center">
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#dc3545',
                  color: 'white'
                }}
              >
                <i className="fas fa-exclamation-triangle fa-lg"></i>
              </div>
              <h5 className="modal-title mb-0" style={{ color: '#dc3545', fontWeight: '600' }}>
                {title}
              </h5>
            </div>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          
          <div className="modal-body pt-2">
            <div className="alert alert-warning border-0" style={{ backgroundColor: '#fff3cd' }}>
              <div className="d-flex align-items-start">
                <i className="fas fa-info-circle text-warning me-2 mt-1"></i>
                <div>
                  <strong>Ação Irreversível</strong>
                  <p className="mb-0 mt-1 text-muted">
                    Esta ação não pode ser desfeita. Todos os dados relacionados serão permanentemente removidos.
                  </p>
                </div>
              </div>
            </div>
            
            <p className="mb-3" style={{ fontSize: '1.1rem', lineHeight: '1.5' }}>
              {message}
            </p>
            
            {itemName && (
              <div className="bg-light p-3 rounded border-start border-4 border-danger">
                <strong>Item a ser excluído:</strong>
                <div className="mt-1" style={{ color: '#dc3545', fontWeight: '500' }}>
                  {itemName}
                </div>
              </div>
            )}
            
            {turmasVinculadas && turmasVinculadas.length > 0 && (
              <div className="bg-light p-3 rounded border-start border-4 border-warning mt-3">
                <strong>Turmas que serão excluídas:</strong>
                <div className="mt-2">
                  {turmasVinculadas.map((turma, index) => (
                    <span key={index} className="badge bg-danger me-1 mb-1" style={{ fontSize: '0.9rem' }}>
                      {turma}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
          
          <div className="modal-footer border-0 pt-0">
            <button 
              type="button" 
              className="btn btn-secondary me-2"
              onClick={onClose}
              disabled={isLoading}
            >
              <i className="fas fa-times me-2"></i>
              Cancelar
            </button>
            <button 
              type="button" 
              className="btn btn-danger"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Excluindo...
                </>
              ) : (
                <>
                  <i className="fas fa-trash me-2"></i>
                  Confirmar Exclusão
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;